import React from "react";
export default function HumanCompany(){
  return(
    <>
    <section className="human-company-area">
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-2 col-md-2 col-6">
            <img src="/assets/images/human-goal-company-logo-1.webp" alt="Company Goal" />
          </div>

          <div className="col-lg-2 col-md-2 col-6">
            <img src="/assets/images/human-goal-company-logo-2.webp" alt="Company Goal" />
          </div>

          <div className="col-lg-2 col-md-2 col-6">
            <img src="/assets/images/human-goal-company-logo-3.webp" alt="Company Goal" />
          </div>

          <div className="col-lg-2 col-md-2 col-6">
            <img src="/assets/images/human-goal-company-logo-4.webp" alt="Company Goal" />
          </div>

          <div className="col-lg-2 col-md-2 col-6">
            <img src="/assets/images/human-goal-company-logo-5.webp" alt="Company Goal" />
          </div>
        </div>
      </div>
    </section>
    </>
  )
}